import { Navigate, Route, Routes } from "react-router-dom";

import ErrorBoundary from "@/components/common/errorBoundary";
import { VerifiedRoute } from "@/components/common/verifiedRoute";
import { IndexRoute } from "@/routes/IndexRoute";
import { ProtectedRoutes } from "@/routes/protectedRoutes";
import { ProviderRoutes } from "@/routes/providerRoutes";
import { PublicRoutes } from "@/routes/publicRoutes";

interface AppRoutesProps {
  authState: any;
  location: any;
}

export const AppRoutes = ({ authState, location }: AppRoutesProps) => {
  return (
    <ErrorBoundary componentName="this page">
      <Routes>
        {/* Index route */}
        <Route
          path="/"
          element={
            <VerifiedRoute authRequired={true}>
              <IndexRoute />
            </VerifiedRoute>
          }
        />

        {ProtectedRoutes({ authState })}
        {ProviderRoutes()}
        {PublicRoutes()}

        {/* Catchall 404 route */}
        <Route
          path="*"
          element={<Navigate to={`/404/?from=${location.pathname}`} />}
        />
      </Routes>
    </ErrorBoundary>
  );
};
